import React, { memo } from 'react'
import { formatDate } from 'utils/formatDatetime'

interface IActivityGroupHeaderProps {
  // ISO string format
  currentDate: string
}

const TODAY = new Date()

export const ActivityGroupHeader = memo<IActivityGroupHeaderProps>(({ currentDate }) => {
  const today = formatDate(TODAY, 'dayMonth')
  const day = formatDate(currentDate, 'dayMonth')

  return (
    <div className='activity-group-header'>
      <span className='activity-group-header-text'>{day === today ? 'Today' : day}</span>
    </div>
  )
})
